var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    _vm._b({}, "v-card", _vm.$attrs, false),
    [
      _c("v-card-title", { staticClass: "title" }, [
        _vm._v("\n    Data Validation Modes\n  "),
      ]),
      _vm._v(" "),
      _c(
        "v-list",
        { attrs: { dense: "" } },
        _vm._l(_vm.descriptions, function (row, i) {
          return _c(
            "v-list-tile",
            { key: `info-row-${i}` },
            [
              _c("v-list-tile-content", [
                _c("span", { staticClass: "font-weight-bold success--text" }, [
                  _vm._v(_vm._s(row.name)),
                ]),
                _vm._v(" " + _vm._s(row.description) + "\n      "),
              ]),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-btn", { attrs: { flat: "", small: "" } }, [_vm._v("Close")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }